import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.user
const _getTokenState = (state: RootState) => state.token

export const getUser = createSelector(_getState, state => state.user)

export const getEmail = createSelector(_getState, state => state.email)

export const getShowFirstUse = createSelector(
  _getState,
  state => state.showFirstUse
)

export const getCheckEmailStatus = createSelector(
  _getState,
  state => state.checkEmailStatus
)

export const getFullName = createSelector(
  _getState,
  state =>
    `${state.user?.firstName ?? ''}
    ${state.user?.middleName ?? ''} 
    ${state.user?.lastName ?? ''}`
)

export const getToken = createSelector(_getTokenState, state => state.token)

export const getPushnotificationsEnabled = createSelector(
  _getState,
  state => state.pushnotificationsEnabled
)
